import styled from '@emotion/styled';

export const StyledTabComponent = styled.div`
    color: ${(props) => props.theme.shades.blackGrey};

    .MuiTab-wrapper {
        font-size: ${(props) => props.theme.fontSize.copyTextXL};
    }

    && .MuiTabs-scroller.MuiTabs-fixed {
        /* super hard override for the inline Mui style */
        overflow: visible !important;
    }

    .MuiTab-fullWidth {
        border-bottom: 1px solid ${(props) => props.theme.shades.lightMidGrey};
    }
`;

export const StyledTabInner = styled.div<{ isSingleView: boolean }>`
    margin: ${(props) => (props.isSingleView ? '10px 0' : '20px 0')};
    font-size: ${(props) => props.theme.fontSize.copyTextL};
`;

export const StyledNonTabHeadline = styled.p`
    font-size: 15px; //not in global fontsizes
    font-weight: 700;
    margin: 30px 0 0;
`;
